import { createContext } from 'react'
import { type Clickstream } from '@gojek/clickstream-web'

export default createContext<Clickstream | null>(null)
